<template>
    <div class="row" v-if="isAvailableForView">
        <div v-if="loading" class="lds-dual-ring"></div>
        <div v-if="!loading" class="col-lg-12 mb-4">
            <div class="box">
                <div class="box-offset">
                    <div class="box-ttl-wrap">
                        <div class="box-ttl">Preconfigured Responses</div>
                    </div>
                    <div class="buttons--row buttons--row-2 mb-3">
                        <div class="search--block">
                            <button
                                class="search--block-btn"
                                type="submit"
                                @click="getResponsesList"
                            ><img src="/img/svg/icons-search.svg" alt=""></button>
                            <input
                                type="search"
                                class="search--block-txt"
                                v-model="filters.search"
                                placeholder="Search by Name"
                                @input="handleSearch"
                            />
                        </div>
                        <div class="filter-wrap">
                            <label for="" class="reg-label mr-2">Filter:</label>
                            <div class="form-group form-group-2 mb-0">
                                <select
                                    class="custom-select"
                                    v-model="filters.status"
                                    @change="getResponsesList"
                                >
                                    <option value="" selected="">Select One</option>
                                    <option value="all" >All </option>
                                    <option value="1">Active</option>
                                    <option value="0">Inactive</option>
                                </select>
                            </div>
                        </div>
                        <a :href="`/master-admin/settings/preconfigured-responses/create`" class="btn btn--outline-primary btn--middle" >+ Add New</a>
                    </div>
                    <div class="table-holder table-responsive">
                        <table class="table">
                            <thead>
                            <tr>
                                <th>
                                    <a href="javascript:void(0)" @click.prevent="changeSortList('subject')">Subject<i class="fas fa-sort"></i></a>
                                </th>
                                <th>
                                    <a href="javascript:void(0)" @click.prevent="changeSortList('email')">Email Message<i class="fas fa-sort"></i></a>
                                </th>
                                <th>
                                    Status
                                </th>
                                <th class="text-right" style="width: 5rem">Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="response in responses" :key="response.id">
                                <td>
                                    <b>{{ response.subject }}</b>
                                </td>
                                <td>
                                    {{ response.message }}
                                </td>
                                <td :class="{
                                        'color--red': response.isActive === false,
                                        'color--green': response.isActive === true
                                    }">
                                    {{response.isActive ? 'Active' : 'Inactive'}}
                                </td>
                                <td class="text-right">
                                    <div class="action-block">
                                        <a
                                            :href="`/master-admin/settings/preconfigured-responses/${response.id}/update`"
                                            class="edit-link"
                                        ><img src="/img/svg/icons-pen.svg" alt="edit"></a>
                                    </div>
                                </td>
                            </tr>

                            </tbody>
                        </table>
                    </div>
                    <Pagination
                        :currentPage="pagination.current_page"
                        :lastPage="pagination.last_page"
                        @changeItemsPerPage="changeItemsPerPage"
                        @changePage="changePage" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ResponsesServices from "./services/ResponsesServices";
import ActionModal from "../../../../../resources/js/components/ActionModal.vue";
import DateConverter from "../../../../../resources/js/mixins/DateConverter";
import SortDirectionHandler from "../../../../../resources/js/mixins/SortDirectionHandler";
import PaginationHandler from "../../../../../resources/js/mixins/PaginationHandler";
import {createDebouncedFunction} from "../../../../../resources/js/plugins/debounce";

export default {
    name: 'ListOfResponses',
    props: {
        isAvailableForView: {
            type: Boolean,
            required: true
        },
    },
    components: {ActionModal},
    mixins: [DateConverter, SortDirectionHandler,PaginationHandler],
    data() {
        return {
            loading: true,
            responses: [],
            filters: {
                search: '',
                status: 'all',
                page: 1,
                perPage: 10
            },
            pagination: {
                current_page: 1,
                last_page: 1,
            },
        }
    },
    methods: {
        getList(filters) {
            this.getResponsesList(filters)
        },
        async getResponsesList() {
            try {
                const {data: response} = await ResponsesServices.getList(this.filters)
                this.responses = response.data
                this.pagination.current_page = response.current_page
                this.pagination.last_page = response.last_page
                this.loading = false

            } catch (error) {
                this.$showErrorMessage();
            }
        },
        handleSearch() {
            this.filters.page = 1
            this.delayedSearch();
        },
    },
    mounted() {
        this.getResponsesList();
        this.delayedSearch = createDebouncedFunction(() => this.getResponsesList(), 500);
    }
}

</script>

<style scoped>

</style>
